const HTTP_WORKFLOW_RUN_ERROR = /^Failed to fetch workflow run: (\d{3})$/;

/**
 * Keeps fetch failures useful without exposing an arbitrary response body or
 * browser error text in the workflow UI.
 */
export function workflowRunLoadErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    const status = HTTP_WORKFLOW_RUN_ERROR.exec(error.message)?.[1];
    if (status) return `Request failed (HTTP ${status}).`;
    if (error.message === "Session expired") {
      return "Your session has expired. Reload the page to sign in again.";
    }
    if (error.message === "Workflow run request timed out") {
      return "Workflow run request timed out. Try again.";
    }
  }

  return "The request did not complete. Try again.";
}
